import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { dealsCategoryService } from "./services/DealsCategory.service";
import DealsCategoryTable from "./DealsCategoryTable";
import DealCategoryForm from "./DealsCategoryForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10,
  imageUrl: null
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false
};

const initailGetState = {
  fetchingCategory: false,
  fetchedCategory: false,
  fetchingError: null,
  selectedRow: null
};

const initailDeleteState = {
  deleting: false,
  deleted: false,
  deleteError: null,
  deleteResponse: null
};

class ManageDealCategories extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    ...initailDeleteState,
    isDeleteButton: false
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAll({ pageNum: pageNum + 1, pageSize });
  }

  getAll = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await dealsCategoryService.getAllCategories(params);
      if (response) {
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          data: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  addCategory = async requestBody => {
    const { pageSize, selectedRow } = this.state;

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,
      formResponse: null,
      formError: null
    });
    try {
      let response = await dealsCategoryService.addCategory(
        requestBody,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState({
          ...this.state,
          submitting: false,
          submitted: true,
          formResponse: response,
          formError: null
        });
        this.getAll({ pageNum: 1, pageSize });
        if (!selectedRow) {
          toast.success("Deals Category created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        } else {
          toast.success("Deals Category updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.resetButton();
        }
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false
      });
    }
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAll(params);

  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  getCategory = async (params, action) => {
    this.setState({
      isDeleteButton: false,
      ...this.state,
      ...initialSubmitState,
      fetchingCategory: true,
      fetchingError: null
    });
    try {
      let response = await dealsCategoryService.getCategory(params);
      if (response) {
        this.setState({
          ...this.state,
          ...initialSubmitState,
          fetchingCategory: false,
          fetchedCategory: true,
          hasParams: true,
          isView: action === "view" ? true : false,
          selectedRow: !!response && response.data,
          isDeleteButton: false,
          imageUrl: response.imageUrl ? response.imageUrl : null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        ...initialSubmitState,
        fetchingCategory: false,
        fetchedCategory: false,
        fetchingError: error,
        selectedRow: null
      });
    }
  };

  selectRow = (selectedRow, action) => {
    this.getCategory(selectedRow.original.id, action);
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false,
      isDeleteButton: true
    });
  };

  showConfirmation = selectedRow => {
    if (this.state.showModal) {
      this.setState({
        showModal: !this.state.showModal
      });
    } else {
      this.setState({
        selectedRow: selectedRow.original,
        showModal: !this.state.showModal
      });
    }
  };

  deleteCategory = item => {
    if (item && item.id) {
      dealsCategoryService
        .deleteCategory(item.id)
        .then(response => {
          this.setState({
            response,
            error: null,
            submitting: false,
            deleting: false,
            deleted: true,
            deleteError: null,
            showModal: false,
            hasParams: false,
            selectedRow: null,
            submitted: false,
            isView: false,
            isDeleteButton: true
          });
          this.fetchData();
          toast.success("Deals Category deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        })
        .catch(error =>
          this.setState({ formError: error, submitting: false }, () => {
            toast.error(this.state.formError.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 4000
            });
          })
        );
    }
    this.setState({
      showModal: !this.state.showModal
    });
  };

  setImageNull = () => {
    this.setState({ imageUrl: null });
  };

  render() {
    const {
      fetching,
      fetched,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      deleting,
      deleted,
      deleteError,
      deleteResponse,
      isView,
      imageUrl,
      fetchedCategory,
      fetchingError,
      fetchingCategory,
      isDeleteButton
    } = this.state;

    return (
      <Row>
        <Col sm="4">
          <DealCategoryForm
            submitting={submitting}
            error={formError}
            hasParams={hasParams}
            selectedRow={selectedRow}
            submitAction={this.addCategory}
            reset={this.resetButton}
            submitted={submitted}
            isView={isView}
            imageUrl={imageUrl}
            setImageNull={this.setImageNull}
            fetchedRow={fetchedCategory}
            fetchingError={fetchingError}
            fetchingRow={fetchingCategory}
            isDeleteButton={isDeleteButton}
          />
        </Col>
        <Col sm="8">
          <DealsCategoryTable
            fetching={fetching}
            fetched={fetched}
            data={data}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            error={error}
            filterData={this.filterData}
            DeleteModal={this.DeleteModal}
            deleteCategory={this.deleteCategory}
            showModal={this.showConfirmation}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            selectRow={this.selectRow}
            routeChange={this.routeChange}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.deleteCategory}
          actionState={{
            sending: deleting,
            sent: deleted,
            error: deleteError,
            response: deleteResponse
          }}
          item={selectedRow}
        />
      </Row>
    );
  }
}

export default ManageDealCategories;
